<script setup lang="ts">
import { onMounted } from 'vue';
import { DEPLOY_MARKER } from '~/common/config';

// OLD SEO Meta
useSeoMeta({
  title: 'SwitchCase',
  description: 'Turning ideas into stunning digital products',
  ogTitle: 'SwitchCase',
  ogDescription: 'Turning ideas into stunning digital products',
  ogImageAlt: 'SwitchCase logo',
  ogImageHeight: '630',
  ogImageWidth: '1200',
  ogImageType: 'image/png',
  ogImage: '/ogImage.png',
  ogType: 'website',
  ogUrl: 'switchcase.dev',
  ogSiteName: 'SwitchCase',
  twitterImage: {
    url: "www.switchcase.dev/ogImage.png",
    alt: "SwitchCase logo",
    type: "image/png",
    width: 1200,
    height: 630,
  },
});

useHead({
  link: [
    { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
    { rel: "icon", type: "image/png", href: "/favicon.png" },
    { rel: "apple-touch-icon", type: "image/png", href: "/apple.png" },
  ],
});

onMounted(() => {
  // Google Tag Manager (GTM)
  const gtmScriptHead = document.createElement('script');
  gtmScriptHead.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KG6Q9293');`;

  const gtmScriptBody = document.createElement('noscript');
  gtmScriptBody.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KG6Q9293" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

  document.head.appendChild(gtmScriptHead);
  document.body.prepend(gtmScriptBody);
});
</script>

<template>
  <div class="app" :class="{ DEPLOY_MARKER }">
    <div class="content-wrapper">
      <app-header />
      <main class="wrapper">
        <slot/>
      </main>
      <app-footer />
    </div>
  </div>
</template>

<style scoped>
.app {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--main-bg);
}

.content-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>
